import { render, staticRenderFns } from "./ComingSoonBanner.vue?vue&type=template&id=829eafcc&scoped=true&"
import script from "./ComingSoonBanner.vue?vue&type=script&lang=js&"
export * from "./ComingSoonBanner.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoonBanner.vue?vue&type=style&index=0&id=829eafcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829eafcc",
  null
  
)

export default component.exports